import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useHistory } from 'react-router-dom';
import '../../../Assets/css/powerAiPage.css'

const PowerAIBanner = () => {
    const history = useHistory();
    return (
        <div className='Power_AI_banner_secction'>
            <Container>
                <Row>
                    <Col sm={12} md={12} lg={12}>
                    <div className='Power_AI_banner_content'>
                        <h1 className='Power_AI_banner_heading'>Smarter Websites<br></br><span>
Start with Smarter AI</span></h1>
                        <p className='Power_AI_banner_sub_heading'>No more manual writing. With our AI-powered product description generator, you can effortlessly craft
SEO-friendly descriptions that showcase your jewelry’s unique charm and help boost your sales.</p>
                        <button onClick={() => { history.push('/consultation') }} className='btn_outline_white'>Book A Free Consultation</button>
                    </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default PowerAIBanner